// Productores.jsx
import React, { useState, useMemo, useEffect } from "react";
import { MdEdit, MdDelete, MdVisibility, MdFilterList } from "react-icons/md";
import PageLayout from "../../../Layouts/PageLayout/PageLayout";
import Table from "../../../components/common/Table/Table";
import Button from "../../../components/common/Button/Button";
import InputSearch from "../../../components/common/Inputs/InputSearch/InputSearch";
import { FiDownload } from "react-icons/fi";
import { GrAdd } from "react-icons/gr";
import { LuArrowDownUp } from "react-icons/lu";
import { CgDanger } from "react-icons/cg";
import { CiClock1, CiCircleCheck } from "react-icons/ci";
import { getApiInstance } from "../../../utils/api";
import { mapList } from "../../../utils/utils";
import { useZone } from "../../../context/ZoneContext";

const columnasProductores = [
    { key: "id", label: "codProductor", visible: false },
    { key: "codProductor", label: "codProductor", visible: false },
    {
        key: "nombre",
        label: "Nombre",
        visible: true,
        isLink: true,
        sortable: true,
    },
    { key: "cif", label: "CIF", visible: true, sortable: true },
    { key: "contacto", label: "Contacto", visible: true, sortable: true },
    { key: "telefono", label: "Teléfono", visible: true, sortable: true },
    { key: "eMail", label: "Email", visible: true, sortable: true },
    { key: "codEstado", label: "Validación", visible: true, sortable: true },
];

const estados = [
    { label: "", type: "info" },
    { label: "Pendiente", type: "info", Icon: CiClock1 },
    { label: "Incidencia", type: "warning", Icon: CgDanger },
    { label: "Validada", type: "success", Icon: CiCircleCheck },
];

const filterFields = [
    { key: "nombre", label: "Nombre", type: "multiselect" },
    { key: "cif", label: "CIF", type: "multiselect" },
    { key: "contacto", label: "Contacto", type: "multiselect" },
    { key: "telefono", label: "Teléfono", type: "multiselect" },
    {
        key: "codEstado",
        label: "Validación",
        type: "cards",
        labelMap: estados.map((estado) => estado.label),
    },
];

export default function Productores() {
    const [productores, setProductores] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [comunidades, setComunidades] = useState([]);
    const [paises, setPaises] = useState([]);
    const [provincias, setProvincias] = useState([]);
    const { selectedZone } = useZone();

    useEffect(() => {
        fetchProductores();
        fetchComunidades();
        fetchPaises();
        fetchProvincias();
    }, [selectedZone]);

    const fetchProductores = async () => {
        setLoading(true);
        const api = getApiInstance();

        try {
            let productoresData = [];

            const response = await api.get(
                `/api/Productores/GetProductoresByZona/${selectedZone.value}`
            );
            productoresData = response.data;

            setProductores(productoresData);
            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar los productores. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchComunidades = async () => {
        setLoading(true);
        const api = getApiInstance();

        try {
            let comunidadesData = [];

            const response = await api.get(
                `/api/Comunidades/GetComunidadesByZona/${selectedZone.value}`
            );
            comunidadesData = response.data;

            setComunidades(
                mapList(
                    comunidadesData,
                    "comunidad",
                    "codComunidad",
                    "codComunidad",
                    "codPais"
                )
            );

            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar las comunidades. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchPaises = async () => {
        setLoading(true);
        const api = getApiInstance();

        try {
            let paisesData = [];

            const response = await api.get(
                `/api/Paises/GetPaisesByZona/${selectedZone.value}`
            );
            paisesData = response.data;

            setPaises(mapList(paisesData, "pais", "codPais", "codPais"));
            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar los países. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchProvincias = async () => {
        setLoading(true);
        const api = getApiInstance();
        try {
            let provinciasData = [];

            const response = await api.get(
                `/api/Provincias/GetProvinciasByZona/${selectedZone.value}`
            );
            provinciasData = response.data;

            setProvincias(
                mapList(
                    provinciasData,
                    "provincia",
                    "codProvincia",
                    "codProvincia",
                    "codComunidad"
                )
            );
            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar las provincias. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    if (error)
        return (
            <div className="muebles-pages__error-message">Error: {error}</div>
        );

    return (
        <PageLayout
            title="Productores"
            subtitle="Gestión de productores registrados en el sistema"
        >
            <Table
                columns={columnasProductores}
                dataTable={productores}
                showCheckboxes={true}
                actions={["Eliminar", "Editar"]}
                elementName="Productor"
                noResultsMessage="No se han encontrado productores."
                searchTerms={[
                    "Nombre",
                    "CIF",
                    "Teléfono",
                    "Email",
                    "Validación",
                ]}
                formElements={[
                    {
                        title: "Información general",
                        titleVisible: true,
                        elements: [
                            {
                                name: "nombre",
                                type: "text",
                                label: "Nombre",
                                placeholder: "Ingrese su nombre",
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "cif",
                                type: "text",
                                label: "CIF",
                                placeholder: "Ingrese el CIF",
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "contacto",
                                type: "tel",
                                label: "Contacto",
                                placeholder: "Ingrese el número de teléfono",
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "telefono",
                                type: "tel",
                                label: "Teléfono",
                                placeholder: "Ingrese el número de teléfono",
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "eMail",
                                type: "email",
                                label: "Email",
                                placeholder: "Ingrese su dirección email",
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                        ],
                    },
                    {
                        title: "Datos representante",
                        titleVisible: true,
                        elements: [
                            {
                                name: "nombreRepresentante",
                                type: "text",
                                label: "Nombre del representante",
                                placeholder:
                                    "Ingrese el nombre del representante",
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "apellidosRepresentante",
                                type: "text",
                                label: "Apellidos del representante",
                                placeholder:
                                    "Ingrese los apellidos del representante",
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "dniRepresentante",
                                type: "text",
                                label: "DNI del representante",
                                placeholder: "Ingrese el DNI del representante",
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "cargoRepresentante",
                                type: "text",
                                label: "Cargo del representante",
                                placeholder:
                                    "Ingrese el cargo del representante",
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "telefonoContacto",
                                type: "tel",
                                label: "Teléfono de contacto",
                                placeholder:
                                    "Ingrese el número de teléfono de contacto",
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "eMailContacto",
                                type: "email",
                                label: "Email de contacto",
                                placeholder:
                                    "Ingrese la dirección email de contacto",
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "cnae",
                                type: "number",
                                label: "CNAE",
                                placeholder: "Ingrese el CNAE",
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                        ],
                    },
                    {
                        title: "Ubicación",
                        titleVisible: true,
                        elements: [
                            {
                                name: "direccion",
                                type: "text",
                                label: "Dirección",
                                placeholder: "Ingrese la dirección",
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "codPais",
                                type: "select",
                                label: "País",
                                placeholder: "Introduce el país",
                                options: paises,
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "codComunidad",
                                type: "select",
                                label: "Comunidad",
                                placeholder: "Introduce la comunidad",
                                options: comunidades,
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                                associatedFormElement: "codPais",
                            },
                            {
                                name: "codProvincia",
                                type: "select",
                                label: "Provincia",
                                placeholder: "Introduce la provincia",
                                options: provincias,
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                                associatedFormElement: "codComunidad",
                            },
                            {
                                name: "localidad",
                                type: "text",
                                label: "Localidad",
                                placeholder:
                                    "Ingrese el nombre de la localidad",
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "cp",
                                type: "text",
                                label: "Código Postal",
                                placeholder: "Ingrese el código postal",
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "codZona",
                                type: "number",
                                label: "Zona",
                                visible: false,
                                defaultValue: "1",
                            },
                        ],
                    },
                ]}
                filterFields={filterFields}
                loading={loading}
                sortProp="nombre"
                addApiUrl="/api/Productores/SetProductor"
                editApiUrl="/api/Productores/UpdateProductor"
                deleteApiUrl="/api/Productores/DeleteProductor"
                keyProp="codProductor"
                stateProp="codEstado"
                states={estados}
            />
        </PageLayout>
    );
}
